import AppNotificationOptionState from './schema/AppNotificationOptionState';
import { createStore } from 'satcheljs';

export default createStore<AppNotificationOptionState>('appNotificationOption', {
    newMailSound: null,
    newMailToast: null,
    reminderSound: null,
    reminderToast: null,
});
